import { Modal, ModalBody, ModalHeader, Text } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core/react/i18n';

import type { Endorsement } from 'src/app/shared/components/endorsements';

import { EndorsementsList } from '../EndorsementsList';

type Props = {
	isOpen: boolean;
	onClose: () => void;
	setIsOpen: (isOpen: boolean) => void;
	endorsements: Endorsement[];
};

export const EndorsementsModal: React.FC<Props> = ({ isOpen, onClose, setIsOpen, endorsements }) => {
	const { translate } = useI18n();

	return (
		<div>
			<Modal isOpen={isOpen} onClose={onClose} onOpenChange={setIsOpen} className="z-10000" size="large">
				<ModalHeader title={translate('corgi.petition.details.endorsements.heading')} />

				<ModalBody className="pt-6">
					<Text variant="body" size="large" className="text-typography-weak">
						{translate('corgi.petition.details.endorsements.subheading')}
					</Text>
					<EndorsementsList showAll endorsements={endorsements} />
				</ModalBody>
			</Modal>
		</div>
	);
};
